import { routes } from "../configs/routes";
import { h } from "./index";
import { toast } from "sonner";

/**
 * Handles api response
 * @param {object} response
 * @param {boolean} [showMessage=true]
 * @returns {Promise<{data: {}, status: string}>}
 */
export async function handleApiResponse(response, showMessage = true) {
    const apiRes = { status: "", data: {} };
    if (!response) return apiRes;
    apiRes.data = response.data || {};
    if (
        h.general.notEmpty(response) &&
        (h.general.cmpStr(response.status, 200) ||
            h.general.cmpStr(response.status, 201))
    ) {
        apiRes.status = "ok";
        if (
            h.general.cmpBool(showMessage, true) &&
            h.general.notEmpty(response.data.message)
        )
            toast(apiRes.data.message, {
                type: "success",
            });
    } else if (
        h.general.notEmpty(response) &&
        (h.general.cmpStr(response.status, 403) ||
            h.general.cmpStr(response.status, 401))
    ) {
        if (response.data.message !== "Invalid email or password") {
            if (!h.general.cmpStr(window.location.pathname, "/login")) {
                window.location = routes.login;
            }
        } else if (response.data.message === "Invalid email or password") {
            toast(apiRes.data.message, {
                type: "error",
            });
        }
    } else if (
        h.general.notEmpty(response) &&
        h.general.cmpStr(response.status, 400)
    ) {
        toast("Uh oh! Something went wrong.", {
            description: "There was a problem with your request.",
            descriptionClassName: "!text-black",
            type: "error",
        });
    } else {
        apiRes.status = "error";
        if (showMessage) {
            toast(apiRes.data.message, {
                type: "error",
            });
        }
    }
    return apiRes;
}
